import React, { Component } from "react";
import { Form, Row, Checkbox, Tooltip } from "antd";
import Button from '@mui/material/Button';
import { backendPostWithoutRefresh } from "../../../helpers/callBackend";
import GenericModal from "../../buttons/genericModal";
import { ArrowRightOutlined } from "@ant-design/icons";
import GenerateCode from "../../formItems/generateCode";

class NewVirtualDebitCardButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            'visible': false,
            'loading': true,
            'verificationToken': '',
            'verificationCode': '',
        };
        this.formRef = React.createRef();
    }

	handleVerificatonCode = async (values) => {
		this.setState({ ...this.state, verificationToken: values.verificationToken, verificationCode: values.verificationCode  });
	};

    onFormSubmitModal = (values) => {
        backendPostWithoutRefresh(
            "/api/bank-account/virtual-debit-card/",
            {
                'verificationToken': this.state.verificationToken,
                'verificationCode': this.state.verificationCode,
                'bank_account_id': this.props.bankAccountId,
            }
        ).then((response) => {
            if (this.formRef.current) {
                this.formRef.current.resetFields();
            }
            this.setState((state) => ({
                ...state, visible: false,
            }));
            this.props.showVirtualDebitCard(response.data.id)
        }).catch((error) => {
            console.error(error);
        })
    };

    render() {
        const userPermission = localStorage.getItem("arpariUserPermission");
        return (
            <GenericModal
                visible={this.state.visible}
                handleCancelModal={() => {
                    if (this.formRef.current) {
                        this.formRef.current.resetFields();
                    }
                    this.setState((prevState) => ({
                        ...prevState,
                        visible: false,
                    }));
                }}
                showModal={() => {
                    if (userPermission === "RO") {
                        return;
                    }
                    this.setState((prevState) => ({
                        ...prevState,
                        visible: true,
                    }));
                }}
                size='md'
                button={
                    <Tooltip title={userPermission === "RO" ? "Not permitted. Please check permission with your admin." : undefined}>
                       <span
                        disabled={userPermission === "RO"}
                        style={userPermission === "RO" ? { cursor: "not-allowed" } : { fontWeight: "400", fontSize: "14px" }}

                        >
                        Virtual Debit Card <ArrowRightOutlined />
                       </span>
                    </Tooltip>
                }
                modalTitle="Add a Virtual Debit Card"
                modalBody={
                    <Form
                        layout="vertical"
                        name="basic"
                        onFinish={this.onFormSubmitModal}
                        autoComplete="off"
                        ref = {this.formRef}
                    >
                        <Row style={{ marginLeft: "10px"}}>
                            <h4 style={{ marginBottom: "30px"}}>Open a virtual debit card connected to this bank account.</h4>
                            <GenerateCode
                                bankAccountId={this.props.bankAccountId}
                                onChange={this.handleVerificatonCode}
                            />
                        </Row>

                        <Form.Item name="agreement" label="" valuePropName="checked">
                            <Checkbox>
                                I agree and acknowledge the
                                <a href='https://www.arpari.com/legal/cardholder-agreement' target="_blank" rel="noreferrer">
                                    {" "} Arpari Cardholder Agreement
                                </a>
                            </Checkbox>
                        </Form.Item>

                        <Form.Item>
                            <Button
                                disableElevation fullWidth size="small" type="submit" variant="contained" color="primary"
                                htmlType="submit"
                                sx={{ fontSize: 14, textTransform: 'none' }}
                                style={{ margin: "3px", marginBottom: "0px", width: "100%" }}
                            >
                                Generate Debit Card
                            </Button>
                        </Form.Item>

                    </Form>
                }
            />
        );
    }
}

export default NewVirtualDebitCardButton;
